module.exports = __webpack_public_path__ + "img/4ab472cbcd9bc85aece61d95dc57637a.png";